import React from "react"
import {
    IntervalPattern,
    ScalePattern,
    Tonality
} from "../../../model/scales"


export function RydIntervalPatternInput({
    selectedScale,
    activeSteps,
    setSelectedScale,
    setActiveSteps
}: {
    selectedScale?: Tonality,
    activeSteps: number[],
    setSelectedScale: (scale: Tonality) => void,
    setActiveSteps: (steps: number[]) => void
}) {
    console.log("Rendering checkboxes for active steps: ", selectedScale, activeSteps);
    // Use selectedScale's activeSteps if available; otherwise, use local activeSteps.
    const currentActiveSteps = selectedScale ? selectedScale.scalePattern.pattern.toActiveSteps() : activeSteps;
    return (
        <div style={{ display: 'flex', marginTop: '10px' }}>
            {Array.from({ length: 12 }).map((_, i) => {
                const isActive = currentActiveSteps.includes(i);
                return (
                    <div key={i} style={{ marginRight: '8px', textAlign: 'center' }}>
                        <input
                            type="checkbox"
                            checked={isActive}
                            onChange={() => {
                                console.log(`Checkbox for step ${i} changed. Current active steps: `, currentActiveSteps);
                                let newActiveSteps: number[];
                                if (currentActiveSteps.includes(i)) {
                                    newActiveSteps = currentActiveSteps.filter(step => step !== i);
                                } else {
                                    newActiveSteps = [...currentActiveSteps, i].sort((a, b) => a - b);
                                }
                                if (selectedScale) {
                                    setSelectedScale(new Tonality(selectedScale.center, new ScalePattern(new IntervalPattern('custom', newActiveSteps))));
                                } else {
                                    // Update local activeSteps if no scale is selected.
                                    setActiveSteps(newActiveSteps);
                                }
                            }}
                        />
                        <div>{i}</div>
                    </div>
                );
            })}
        </div>
    );
}